






// @ is an alias to /src
import { Component, Vue, Watch } from 'vue-property-decorator'
import EditBasePiscine from '@/components/administration/piscine/edit/EditBasePiscine.vue'
import * as rules from '@/utils/validationRules'
import { toNumberLookup, toStringDictionary } from '@/utils/groupBy'
import { getDefaultAloPiscine } from '@/models/alo/AloPiscine'
import { AloPiscine } from '@/models/alo/AloPiscine'
import EditTemplateCoursItem from '@/components/administration/piscine/edit/EditTemplateCoursItem.vue'
import { AloTemplateCours, getDefaultAloTemplateCours } from '@/models/alo/AloTemplateCours'
import cloneDeep from 'clone-deep'

@Component({
  name: 'EditTemplateCours',    
  components:{EditBasePiscine,EditTemplateCoursItem}
})
export default class EditTemplateCours extends Vue {
      
  private piscine:AloPiscine = getDefaultAloPiscine()  
  private activitesCours = [] as Array<AloTemplateCours>

  edit(item:AloPiscine) {    
    this.piscine = (this.$refs.baseEdit as EditBasePiscine).edit(item)    
    this.activitesCours = this.activityList.reduce((cours,activity) => {
      if(!!this.coursByActivity[activity.id]){
        this.coursByActivity[activity.id].forEach(tc =>{
          const tpc = cloneDeep(tc)
          tpc.selected = true
          cours.push(tpc)
        })
      }
      else{
        cours.push(getDefaultAloTemplateCours(this.piscine.id, activity))
      }
      return cours
    },[] as Array<AloTemplateCours>)      
  }

  @Watch('activitesCours', {deep: true })
  onActivitesCoursChanged(){
    this.piscine.templateCours = this.activitesCours.filter(a => a.selected)
  }  
  
  get configuration(){
    return this.$store.myGetters.configuration
  }

  get activityList() {
    return this.$store.myGetters.activityList
  }
  
  get coursByActivity() {
    return toNumberLookup(this.piscine.templateCours,t => t.acyId)     
  }
   
  save(){

  }
 
  ruleRequired(v:string) {
    return rules.ruleRequired(v)
  }  
      
} 
